module.exports = __webpack_public_path__ + "img/3.22e42392.png";